// Gallery script
document.addEventListener('DOMContentLoaded', function () {
  // --------------------------------------------------
  // CONFIG
  // --------------------------------------------------

  var COLORS = [
    'Cobalt Blue',
    'Chocolate Brown',
    'Rust Brown',
    'Camel Brown',
    'Sunset Orange',
    'Stone Gray',
    'Burgundy',
    'Black'
  ];

  var HARDWARE = [
    'Gold',
    'Silver'
  ];


  // --------------------------------------------------
  // HELPERS
  // --------------------------------------------------

  function normalizeName(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, '_')
      .toLowerCase();
  }


  var COLOR_KEYS = COLORS.map(function (color) {
    return {
      name: color,
      key: normalizeName(color)
    };
  });


  var HARDWARE_KEYS = HARDWARE.map(function (hardware) {
    return {
      name: hardware,
      key: normalizeName(hardware)
    };
  });


  function getImageText(element) {
    var img = element.querySelector('img');

    if (!img) {
      return '';
    }

    var src =
      img.currentSrc ||
      img.getAttribute('src') ||
      img.src ||
      '';

    var alt = img.alt || '';

    try {
      src = decodeURIComponent(src);
    } catch (e) {}

    return (src + ' ' + alt).toLowerCase();
  }


  function getImageColor(element) {
    var imageText = getImageText(element);

    for (var i = 0; i < COLOR_KEYS.length; i++) {
      var colorKey = COLOR_KEYS[i].key;

      if (
        imageText.indexOf(
          '_' + colorKey + '_'
        ) !== -1
      ) {
        return colorKey;
      }
    }

    return null;
  }


  function getImageHardware(element) {
    var imageText = getImageText(element);

    for (var i = 0; i < HARDWARE_KEYS.length; i++) {
      var hardwareKey =
        HARDWARE_KEYS[i].key;

      if (
        imageText.indexOf(
          '_' + hardwareKey + '_'
        ) !== -1
      ) {
        return hardwareKey;
      }
    }

    return null;
  }


  // --------------------------------------------------
  // SELECTED OPTIONS
  // --------------------------------------------------

  function getSelectedColor() {
    var input = document.querySelector(
      '.swatch-input__input[name^="Color"]:checked, ' +
      'input[name^="Color"]:checked'
    );

    return input ? input.value : '';
  }


  function getSelectedHardware() {
    var input = document.querySelector(
      '.swatch-input__input[name^="Hardware"]:checked, ' +
      'input[name^="Hardware"]:checked'
    );

    if (!input) {
      return '';
    }

    var value = input.value.trim();

    return value;
  }


  // --------------------------------------------------
  // MATCH IMAGE TO SELECTED VARIANT
  // --------------------------------------------------

  function itemMatchesVariant(
    element,
    selectedColor,
    selectedHardware
  ) {
    var imageColor =
      getImageColor(element);

    var imageHardware =
      getImageHardware(element);

    var colorKey =
      normalizeName(selectedColor);

    var hardwareKey =
      normalizeName(selectedHardware);


    // Must match selected color
    if (imageColor !== colorKey) {
      return false;
    }


    // If image contains hardware,
    // it must match selected hardware
    if (
      imageHardware &&
      hardwareKey &&
      imageHardware !== hardwareKey
    ) {
      return false;
    }


    return true;
  }


  // --------------------------------------------------
  // FILTER GALLERY
  // --------------------------------------------------

  function updateImagesForVariant() {
    var selectedColor =
      getSelectedColor();

    var selectedHardware =
      getSelectedHardware();


    if (!selectedColor) {
      return;
    }


    var mainMediaItems =
      document.querySelectorAll(
        '.product__media-item, [data-media-id]'
      );


    var thumbnailItems =
      document.querySelectorAll(
        '.thumbnail-list__item, ' +
        '.product__media-thumbnail'
      );


    var firstVisibleThumbButton =
      null;


    // ----------------------------------------------
    // THUMBNAILS
    // ----------------------------------------------

    thumbnailItems.forEach(function (thumb) {
      var matches =
        itemMatchesVariant(
          thumb,
          selectedColor,
          selectedHardware
        );


      if (matches) {
        thumb.style.display = '';

        if (!firstVisibleThumbButton) {
          firstVisibleThumbButton =
            thumb.querySelector(
              'button, a, img'
            );
        }
      } else {
        thumb.style.display = 'none';
      }
    });


    // ----------------------------------------------
    // MAIN MEDIA
    // ----------------------------------------------

    mainMediaItems.forEach(function (item) {
      var matches =
        itemMatchesVariant(
          item,
          selectedColor,
          selectedHardware
        );

      item.style.display =
        matches ? '' : 'none';
    });


    // ----------------------------------------------
    // SELECT FIRST VISIBLE IMAGE
    // ----------------------------------------------

    if (
      firstVisibleThumbButton &&
      typeof firstVisibleThumbButton.click ===
        'function'
    ) {
      firstVisibleThumbButton.click();
    }
  }


  // --------------------------------------------------
  // HARDWARE AVAILABILITY
  // --------------------------------------------------

  function getHardwareInputs() {
    return document.querySelectorAll(
      'variant-selects input[name^="Hardware"]'
    );
  }


  function fixUnavailableHardware() {
    var attempts = 0;
    var maxAttempts = 30;


    function check() {
      attempts++;


      // Re-query every time because Dawn
      // may update/replace variant elements.
      var selectedHardware =
        document.querySelector(
          'variant-selects input[name^="Hardware"]:checked'
        );


      if (!selectedHardware) {
        return;
      }


      // If current hardware became unavailable...
      if (
        selectedHardware.classList.contains(
          'disabled'
        )
      ) {
        var hardwareInputs =
          getHardwareInputs();


        var availableHardware =
          Array.prototype.find.call(
            hardwareInputs,
            function (input) {
              return !input.classList.contains(
                'disabled'
              );
            }
          );


        if (availableHardware) {
          // Use real click so Dawn runs
          // its normal variant-selection logic.
          availableHardware.click();

          return;
        }
      }


      /*
       * Dawn may not have updated .disabled yet.
       * Keep checking for a short period.
       */
      if (attempts < maxAttempts) {
        requestAnimationFrame(check);
      }
    }


    requestAnimationFrame(check);
  }


  // --------------------------------------------------
  // BLOCK CLICKS ON DISABLED HARDWARE
  // --------------------------------------------------

  document.addEventListener(
    'click',
    function (e) {
      var label = e.target.closest(
        'variant-selects input[name^="Hardware"] + label'
      );

      if (!label) {
        return;
      }


      var input =
        label.previousElementSibling;


      if (
        input &&
        input.matches(
          'input[name^="Hardware"]'
        ) &&
        input.classList.contains(
          'disabled'
        )
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );


  // --------------------------------------------------
  // PRELOAD PRODUCT IMAGES
  // --------------------------------------------------

  function preloadProductImages() {
    var imgs =
      document.querySelectorAll(
        '.product__media-item img, ' +
        '.product__media-thumbnail img, ' +
        '.thumbnail-list__item img'
      );


    imgs.forEach(function (img) {
      if (!img) {
        return;
      }


      var src =
        img.dataset.src ||
        img.currentSrc ||
        img.src;


      if (!src) {
        return;
      }


      var preloadImg =
        new Image();

      preloadImg.src =
        src;
    });
  }


  // --------------------------------------------------
  // INIT
  // --------------------------------------------------

  preloadProductImages();

  updateImagesForVariant();

  fixUnavailableHardware();


  // --------------------------------------------------
  // VARIANT CHANGES
  // --------------------------------------------------

  document.addEventListener(
    'change',
    function (e) {
      var target =
        e.target;


      if (!target) {
        return;
      }


      // ----------------------------------------------
      // COLOR
      // ----------------------------------------------

      if (
        target.matches(
          '.swatch-input__input[name^="Color"], ' +
          'input[name^="Color"]'
        )
      ) {
        /*
         * First let Dawn determine which hardware
         * options are available for the new color.
         */
        fixUnavailableHardware();


        /*
         * Update once immediately.
         *
         * If hardware gets auto-switched afterward,
         * that hardware click/change will update
         * the gallery again.
         */
        updateImagesForVariant();

        return;
      }


      // ----------------------------------------------
      // HARDWARE
      // ----------------------------------------------

      if (
        target.matches(
          '.swatch-input__input[name^="Hardware"], ' +
          'input[name^="Hardware"]'
        )
      ) {
        updateImagesForVariant();
      }
    }
  );
});

// IWT Script
document.addEventListener('DOMContentLoaded', function () {
  var COLORS = [
    'Cobalt Blue',
    'Chocolate Brown',
    'Rust Brown',
    'Camel Brown',
    'Sunset Orange',
    'Stone Gray',
    'Burgundy',
    'Black'
  ];

  var HARDWARE = [
    'Gold',
    'Silver'
  ];


  function normalizeName(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, '_');
  }


  var colorKeys = COLORS.map(normalizeName);
  var hardwareKeys = HARDWARE.map(normalizeName);


  // --------------------------------------------------
  // SELECTED COLOR
  // --------------------------------------------------

  function getSelectedColor() {
    var input = document.querySelector(
      '.swatch-input__input[name^="Color"]:checked, ' +
      'input[name^="Color"]:checked'
    );

    return input ? normalizeName(input.value) : '';
  }


  // --------------------------------------------------
  // SELECTED HARDWARE
  // --------------------------------------------------

  function getSelectedHardware() {
    var input = document.querySelector(
      '.swatch-input__input[name^="Hardware"]:checked, ' +
      'input[name^="Hardware"]:checked'
    );

    // Product has no Hardware variant
    if (!input) return '';

    var value = input.value.trim();

    return value;
  }

  // --------------------------------------------------
  // SYNC HARDWARE WORDS IN IWT TEXT
  // --------------------------------------------------
  function updateIwtHardwareText() {
    var hardware = getSelectedHardware();

    // Product has no Hardware variant -> don't change text
    if (!hardware) {
      return;
    }

    var paragraphs = document.querySelectorAll(
      '.image-with-text__text.rte.body p, ' +
      '.image-with-text__text.rte.body li'
    );

    paragraphs.forEach(function (p) {
      p.innerHTML = p.innerHTML.replace(
        /\b(Gold|gold|Silver|silver)\b/g,
        function (match) {
          // Preserve lowercase if original word was lowercase
          if (match === match.toLowerCase()) {
            return hardware.toLowerCase();
          }

          return hardware;
        }
      );
    });
  }


  // --------------------------------------------------
  // FIND / PARSE IWT IMAGES
  // --------------------------------------------------

  var iwtImages = [];


  document
    .querySelectorAll('.image-with-text__media img')
    .forEach(function (img) {

      var src = img.getAttribute('src') || '';

      if (!src) return;


      // Get filename
      var pathParts = src.split('/');
      var fileWithQuery = pathParts[pathParts.length - 1];

      var baseAndQuery = fileWithQuery.split('?');

      var baseName = baseAndQuery[0];

      var query = baseAndQuery[1]
        ? '?' + baseAndQuery[1]
        : '';


      var lastDot = baseName.lastIndexOf('.');

      if (lastDot === -1) return;


      var nameWithoutExt = baseName.slice(
        0,
        lastDot
      );

      var ext = baseName.slice(
        lastDot
      );


      var foundColor = null;
      var foundHardware = null;

      var prefix = null;
      var suffix = null;


      // ------------------------------------------------
      // FIND COLOR
      // ------------------------------------------------

      for (var i = 0; i < colorKeys.length; i++) {
        var color = colorKeys[i];

        var colorSegment =
          '_' + color + '_';

        var colorIndex =
          nameWithoutExt.indexOf(
            colorSegment
          );


        if (colorIndex !== -1) {
          foundColor = color;

          // Everything before color
          prefix =
            nameWithoutExt.slice(
              0,
              colorIndex + 1
            );

          // Everything after color
          suffix =
            nameWithoutExt.slice(
              colorIndex +
              colorSegment.length
            );

          break;
        }
      }


      // Image is not color-dependent
      if (!foundColor) {
        return;
      }


      // ------------------------------------------------
      // FIND HARDWARE IN ORIGINAL FILENAME
      // ------------------------------------------------

      for (var h = 0; h < hardwareKeys.length; h++) {
        var hardware =
          hardwareKeys[h];

        var hardwarePrefix =
          hardware + '_';


        /*
         * Example:
         *
         * Italian_Leather_Keychain_Cobalt_Blue_Silver_2
         *
         * suffix at this point:
         *
         * Silver_2
         */
        if (
          suffix &&
          suffix.indexOf(
            hardwarePrefix
          ) === 0
        ) {
          foundHardware =
            hardware;

          /*
           * Remove hardware from suffix.
           *
           * Silver_2
           *
           * becomes:
           *
           * 2
           */
          suffix =
            suffix.slice(
              hardwarePrefix.length
            );

          break;
        }
      }


      // ------------------------------------------------
      // STORE ORIGINAL DATA
      // ------------------------------------------------

      var root = src.slice(
        0,
        src.lastIndexOf('/') + 1
      );

      var srcsetTemplate =
        img.getAttribute('srcset') || '';


      img.dataset.iwtRoot =
        root;

      img.dataset.iwtPrefix =
        prefix;

      img.dataset.iwtSuffix =
        suffix;

      img.dataset.iwtExt =
        ext;

      img.dataset.iwtQuery =
        query;

      img.dataset.iwtBaseFile =
        baseName;

      img.dataset.iwtSrcsetTemplate =
        srcsetTemplate;


      // Does filename contain Gold / Silver?
      img.dataset.iwtHasHardware =
        foundHardware
          ? 'true'
          : 'false';


      /*
       * IMPORTANT:
       *
       * Remember original hardware.
       *
       * This is used for products like Keychains
       * that have _Silver_ / _Gold_ in filenames
       * but DON'T have a Hardware variant selector.
       */
      img.dataset.iwtOriginalHardware =
        foundHardware || '';


      iwtImages.push(img);
    });


  if (!iwtImages.length) {
    return;
  }


  // --------------------------------------------------
  // UPDATE IWT IMAGES
  // --------------------------------------------------

  function updateIwtImages() {
    var color =
      getSelectedColor();

    var hardware =
      getSelectedHardware();


    if (!color) {
      return;
    }


    iwtImages.forEach(function (img) {

      var root =
        img.dataset.iwtRoot;

      var prefix =
        img.dataset.iwtPrefix;

      var suffix =
        img.dataset.iwtSuffix;

      var ext =
        img.dataset.iwtExt;

      var query =
        img.dataset.iwtQuery || '';

      var baseFile =
        img.dataset.iwtBaseFile;

      var srcsetTemplate =
        img.dataset.iwtSrcsetTemplate || '';

      var hasHardware =
        img.dataset.iwtHasHardware === 'true';

      var originalHardware =
        img.dataset.iwtOriginalHardware || '';


      // ------------------------------------------------
      // BUILD NEW KEY
      // ------------------------------------------------

      var newKey =
        color;


      /*
       * Image filename contains hardware.
       *
       * If product HAS a Hardware variant:
       * use selected hardware.
       *
       * If product DOES NOT have Hardware variant:
       * keep hardware from original filename.
       */
      if (hasHardware) {
        var hardwareToUse =
          hardware || originalHardware;


        if (hardwareToUse) {
          newKey +=
            '_' + hardwareToUse;
        }
      }


      // ------------------------------------------------
      // BUILD NEW FILENAME
      // ------------------------------------------------

      var newBaseName =
        prefix +
        newKey +
        '_' +
        suffix +
        ext;


      // ------------------------------------------------
      // UPDATE SRC
      // ------------------------------------------------

      var newSrc =
        root +
        newBaseName +
        query;


      img.setAttribute(
        'src',
        newSrc
      );


      // ------------------------------------------------
      // UPDATE SRCSET
      // ------------------------------------------------

      if (srcsetTemplate) {
        var newSrcset =
          srcsetTemplate
            .split(baseFile)
            .join(newBaseName);


        img.setAttribute(
          'srcset',
          newSrcset
        );
      }
    });

    updateIwtHardwareText();
  }


  // --------------------------------------------------
  // INITIAL UPDATE
  // --------------------------------------------------

  updateIwtImages();


  // --------------------------------------------------
  // COLOR + HARDWARE CHANGES
  // --------------------------------------------------

  document.addEventListener(
    'change',
    function (e) {

      var target =
        e.target;


      if (!target) {
        return;
      }


      if (
        target.matches(
          '.swatch-input__input[name^="Color"], ' +
          'input[name^="Color"], ' +
          '.swatch-input__input[name^="Hardware"], ' +
          'input[name^="Hardware"]'
        )
      ) {
        updateIwtImages();
      }
    }
  );
});

document.addEventListener('DOMContentLoaded', function () {
  var modal, modalInner, modalClose;
  var BODY_LOCK_CLASS = 'vd-gallery-modal-open';

  // Inject styles so this whole feature is removable with this single script
  function injectModalStyles() {
    if (document.getElementById('vd-gallery-modal-styles')) return;

    var style = document.createElement('style');
    style.id = 'vd-gallery-modal-styles';
    style.textContent = `
      /* Lock page scroll when modal is open */
      html.vd-gallery-modal-open,
      html.vd-gallery-modal-open body {
        overflow: hidden;
      }

      /* Modal wrapper */
      .vd-gallery-modal {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: none;
      }

      /* When open */
      .vd-gallery-modal.is-open {
        display: block;
      }

      /* Dark backdrop */
      .vd-gallery-modal__backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.75);
      }

      /* Content wrapper */
      .vd-gallery-modal__content {
        position: fixed;
        inset: 0;
        display: flex;
        flex-direction: column;
        pointer-events: none;
        background: rgba(255,255,255,0.7);
      }

      /* Close button */
      .vd-gallery-modal__close {
        position: fixed;
        top: 16px;
        right: 16px;
        z-index: 2;
        pointer-events: auto;
        background: white;
        color: black;
        border: solid 1px black;
        border-radius: 999px;
        font-size: 26px;
        width: 40px;
        height: 40px;
        line-height: 1;
        cursor: pointer;
        font-weight: 100;
        font-family: auto;
      }

      /* Scrollable inner area */
      .vd-gallery-modal__inner {
        position: relative;
        z-index: 1;
        pointer-events: auto;
        margin: 60px auto 40px;
        padding: 0 16px 40px;
        max-width: 1000px;
        max-height: calc(100vh - 80px);
        overflow-y: auto;
      }

      /* Each stacked image */
      .vd-gallery-modal__image-wrap {
        margin-bottom: 10px;
      }

      .vd-gallery-modal__image {
        display: block;
        width: 100%;
        height: auto;
        border-radius: 0px;
        background: #000;
      }

      /* Mobile tweaks */
      @media (max-width: 749px) {
        .vd-gallery-modal__inner {
          margin: 60px 0 40px;
          max-width: 100%;
        }

        .vd-gallery-modal__image-wrap {
          margin-bottom: 10px;
        }

        .vd-gallery-modal__close {
          padding-bottom: 1px;
        }
      }

      @media (min-width: 750px) {
        .vd-gallery-modal__close {
          padding-bottom: 4px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function createModalIfNeeded() {
    if (modal) return;

    injectModalStyles();

    modal = document.createElement('div');
    modal.className = 'vd-gallery-modal';
    modal.innerHTML = `
      <div class="vd-gallery-modal__backdrop"></div>
      <div class="vd-gallery-modal__content">
        <button type="button" class="vd-gallery-modal__close" aria-label="Close gallery">
          &times;
        </button>
        <div class="vd-gallery-modal__inner"></div>
      </div>
    `;

    document.body.appendChild(modal);
    modalInner = modal.querySelector('.vd-gallery-modal__inner');
    modalClose = modal.querySelector('.vd-gallery-modal__close');

    // Close handlers
    modal
      .querySelector('.vd-gallery-modal__backdrop')
      .addEventListener('click', closeModal);
    modal.addEventListener('click', closeModal);
    modalClose.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }

  function openModalFromClicked(target) {
    createModalIfNeeded();

    // Find the clicked media item
    var clickedItem = target.closest('.product__media-item, [data-media-id]');
    if (!clickedItem) return;

    // Collect only visible main media items (already filtered by your color script)
    var allMediaItems = document.querySelectorAll(
      '.product__media-item, [data-media-id]'
    );

    var visibleItems = Array.prototype.filter.call(allMediaItems, function (item) {
      // If explicitly hidden with inline display:none, skip
      if (item.style && item.style.display === 'none') return false;
      // You can add more conditions here if your theme marks hidden ones differently
      return true;
    });

    if (!visibleItems.length) return;

    // Clear previous modal content
    modalInner.innerHTML = '';

    var scrollToIndex = 0;

    visibleItems.forEach(function (item, index) {
      var img = item.querySelector('img');
      if (!img) return;

      var fullSrc = img.currentSrc || img.src;
      if (!fullSrc) return;

      var modalImgWrap = document.createElement('div');
      modalImgWrap.className = 'vd-gallery-modal__image-wrap';

      var modalImg = document.createElement('img');
      modalImg.className = 'vd-gallery-modal__image';
      modalImg.src = fullSrc;
      modalImg.alt = img.alt || '';

      modalImgWrap.appendChild(modalImg);
      modalInner.appendChild(modalImgWrap);

      if (item === clickedItem) {
        scrollToIndex = index;
      }
    });

    // Show modal
    modal.classList.add('is-open');
    document.documentElement.classList.add(BODY_LOCK_CLASS);

    // Scroll to the clicked image
    var modalImages = modalInner.querySelectorAll('.vd-gallery-modal__image-wrap');
    if (modalImages[scrollToIndex]) {
      modalImages[scrollToIndex].scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    } else if (modalImages[0]) {
      modalImages[0].scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove(BODY_LOCK_CLASS);
  }

  // Intercept clicks on gallery triggers and open our modal instead
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '.product__media-item button, ' +
      '.product__media-item a, ' +
      '.product__media-item img, ' +
      '.product__media-item .product__media-icon--lightbox, ' +
      '[data-media-id] button, ' +
      '[data-media-id] a, ' +
      '[data-media-id] img, ' +
      '[data-media-id] .product__media-icon--lightbox'
    );

    if (!trigger) return;

    // Ignore clicks inside our modal
    if (e.target.closest('.vd-gallery-modal')) return;

    // Prevent Dawn's own zoom/modal
    e.preventDefault();
    e.stopPropagation();

    openModalFromClicked(trigger);
  });

});


document.addEventListener('DOMContentLoaded', function () {
  // Desktop-only interactive hover zoom
  if (window.innerWidth < 990) return; // only run on desktop

  // Inject CSS for zoom container + image
  var zoomStyle = document.createElement('style');
  zoomStyle.type = 'text/css';
  zoomStyle.textContent = `
    .vd-hover-zoom-container {
      overflow: hidden;
      position: relative;
    }

    .vd-hover-zoom-img {
      transition: transform 0.25s ease-out;
      will-change: transform, transform-origin;
      display: block;
      width: 100%;
      height: auto;
    }
  `;
  document.head.appendChild(zoomStyle);

  // Target main product media items (not thumbnails)
  var zoomItems = document.querySelectorAll(
    '.product__media-list .product__media-item, ' +
    '.product__media-wrapper .product__media-item'
  );

  zoomItems.forEach(function (item) {
    var img = item.querySelector('img');
    if (!img) return;

    item.classList.add('vd-hover-zoom-container');
    img.classList.add('vd-hover-zoom-img');

    var SCALE = 1.5;

    // Only react when mouse is over the image itself
    img.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(' + SCALE + ')';
    });

    img.addEventListener('mouseleave', function () {
      img.style.transform = '';
      img.style.transformOrigin = '';
    });

    img.addEventListener('mousemove', function (e) {
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
    });
  });
});